module.exports = {
  "FoodC_statement__1_eIic": "(1) After the courier has picked up the package, the recipient must be available to answer their phone and be present at the dropoff location to meet the courier on time.",
  "FoodC_statement_Laboratory_samples_AmoJ": "Laboratory samples;",
  "sailing.c-api-intl.安全码无效，请核对信息后重试": "Please contact your bank and try again. Or change another card to pay.",
  "FoodC_cancel_Cancellation_Policy_rnAp": "Cancellation Policy",
  "Entrega_order__grnd": "Help Center",
  "Entrega_orderlist__qmSV": "Recipient’s Address",
  "Entrega_order__aMgd": "Delivery Note",
  "FoodC_001_The_WEB_Iizt": "Web version currently does not support PayPay payments. To use PayPay, please download {{download}}",
  "Entrega_batches__rZib": "Dropoff Location {{number}}",
  "Entrega_batches__nFnq": "Up to {{number}} orders can be uploaded at a time",
  "FoodB_modification_Confirmation_ehVU": "OK",
  "Entrega_orderlist__sjgm": "Enter search keywords",
  "Entrega_order__LzLZ": "Exit",
  "Entrega_order__eiaZ": "Type",
  "FoodC_cancel__free_BQFd": "Customer may cancel for free within {{free_time}} min(s) after the courier has accepted the order",
  "Entrega_order__uvJi": "Exit",
  "Entrega_Website__Slmd": "Please read and agree to the terms and conditions",
  "Entrega_Website__DZVX": "Please enter your mother’s maiden name",
  "sailing.c-api-intl.[收藏]_[操作太快]": "Too many attempts. Please try again later",
  "FoodC_cancel_Special_circumstances_aOpL": "Special circumstances",
  "Entrega_adaptability_IzCw_ONwx": "Calculate",
  "Entrega_Website__FUwp": "Save",
  "FoodC_IM_Search_no_GwBf": "No results found",
  "Entrega_Website__PxMa": "Store Tax Number",
  "Entrega_order__xvAp": "Please enter sender’s last name",
  "FoodC_statement__4_YGAs": "(4) Aside from fees associated with cash orders, you do not need to pay any other fees to the courier.",
  "FoodB_remind_Update_successfully_dcQL": "Updated successfully",
  "Entrega_batches__mqeT": "Enter first name",
  "Entrega_batches__cpOw": "5. Place the order.",
  "Entrega_order__ZAuG": "Got it",
  "Entrega_batches__uktp": "Enter last name",
  "Entrega_frontpage__opFP": "Send multiple packages at the same time with bulk shipments",
  "FoodB_DishesMerchants_Original_price_huUe": "Original Price",
  "FoodC_statement__2_ZtHa": "(2) When handing over the package to the courier, the sender must verify the courier’s identity. The sender assumes all liability if the package is provided to someone other than the specified courier;",
  "FoodC_C_Cancel_Cqxt": "Cancel",
  "Entrega_order__YnnH": "DiDi Entrega Business",
  "FoodOpD_Part2_Steps_WZjI": "Step",
  "Entrega_order__jjRu": "Contact Us",
  "Entrega_order__hPwP": "Please enter an address / mobile number / name to search",
  "Entrega_frontpage__AseG": "Real-time GPS tracking for you and your customers",
  "Entrega_orderlist__KviE": "All Orders",
  "Entrega_order__OCDq": "The delivery fee may vary depending on your city, the distance between the sender and recipient, the delivery date and delivery time",
  "Entrega_1__KChO": "Internal Code",
  "Entrega_Template__EeTB": "Postal code",
  "Entrega_order__Ftqh": "Mobile Number",
  "Entrega_Website__XohT": "Password",
  "Entrega_order__Lmqk": "Up to {{number}} recipients are allowed at a time",
  "Entrega_order__hRIq": "This will delete all order information entered. Continue?",
  "Entrega_Template__IWlP": "Type",
  "Entrega_frontpage__wLFi": "Safe and Secure",
  "soda-c-i18n---订单取消成功": "Order cancelled!",
  "FoodC_statement__1_wZhz": "(1) If your order is not accepted by a courier after the specified waiting period, you may cancel the order for free;",
  "Entrega_frontpage__mqNg": "Set multiple delivery addresses: Each courier can carry up to three packages at a time",
  "FoodC_demand_Determination_wKQX": "Confirm",
  "FoodC_cancel_Free_order_WqpG": "Customer can cancel order for free",
  "Entrega_orderlist__oXqh": "Copy Link",
  "Entrega_Website__xEde": "Details",
  "Entrega_batches__KCbP": "3. Save the document on your computer, then upload it.",
  "FoodC_web_Customer_Service_EBqf": "Customer Service",
  "Entrega_frontpage__sdCG": "Make deliveries",
  "FoodC_cancel_Courier_picked_obrP": "Order picked up by courier",
  "Entrega_batches__kvFM": "Please select address",
  "GDriver_Name_DiDi_Gsik": "DiDi",
  "Entrega_Template__JAlv": "Template for Batch Orders",
  "soda-b-homepage-i18n---最多不能超过%s个字": "Cannot exceed %s characters",
  "FoodC_name_DiDi_Flash_TAPX": "DiDi Entrega",
  "Entrega_order__sPko": "Please enter sender’s first name",
  "FoodB_5_Payment_Method_qlAx": "Payment Method",
  "Entrega_name_99_Flash_maAd": "99Entrega",
  "FoodC_statement__3_gBJT": "(3) Once the courier has picked up the package, the order fee will not be refunded if you cancel;",
  "sailing.b-api-intl.滴滴外卖": "DiDi Food",
  "FoodC_cancel_Cancel_the_MyBx": "Status",
  "sailing.c-api-intl.余额不足，请更换其他支付方式": "Balance insufficient. Please choose another card or change the method of payment to pay your ride.",
  "FoodC_revision_Contact_customer_GIZy": "Contact Customer Service",
  "FoodC_statement__2_Rrwp": "(2) After the courier has picked up the package, both the sender and recipient will receive a Delivery PIN; if the recipient does not receive the Delivery PIN via SMS, the sender can share the delivery status and Delivery PIN to the recipient from the Order Details page, or contact Customer Service to confirm the Delivery PIN. To ensure secure package delivery, please do not share the Delivery PIN with the courier or anyone else until package is received.",
  "Entrega_Template__ESnk": "Dropoff Information - Add as many dropoff entries as you want",
  "Entrega_orderlist__bEoA": "Ongoing Orders",
  "FoodD_model_Upload_MoFF": "Upload",
  "Entrega_order__KZeQ": "Recipient’s Address",
  "FoodC_statement_2_How_LmUD": "2. How do I use {{entrega_name}}?",
  "FoodD_Compliance_Cancel_RytB": "Cancel",
  "dchat_QR_code_copy_failed": "Copy failed",
  "FoodC_statement__5_eCLd": "(5) If your order is cancelled due to an accident, vehicle malfunction or other reason involving the courier while on the way to pick up the package, another courier will be assigned automatically to pick up the package for you;",
  "Entrega_orderlist__xjSm": "Reset",
  "Entrega_orderlist__VGtl": "Order No.",
  "Entrega_Website__nfLq": "Email",
  "sailing.launcher-xtx-center.支付成功": "Payment successful",
  "FoodC_presentation_DiDi_Delivery_vrwd": "DiDi Entrega",
  "FoodC_busy_System_busy_QOvT": "System is busy. Please try again later",
  "FoodB_additional_Countless_STVD": "No data",
  "Entrega_Website__uokP": "Please enter store’s tax number",
  "Entrega_order__moic": "Attention",
  "Entrega_Template__QpcU": "Weight",
  "Entrega_frontpage__jDZF": "Practical and Convenient",
  "Entrega_batches__QUdn": "There’s an issue with the details for Order #{{num}}. Please check and try again",
  "Entrega_frontpage__TcWu": "Welcome to {{brand_name}}. Send multiple packages at a time, and track the progress of each one",
  "soda-act---添加信用卡/借记卡": "Add credit/debit card",
  "Entrega_order__pjxR": "Add a Recipient’s Address",
  "Entrega_Template__gvzH": "Neighborhood",
  "Entrega_orderlist__LsHL": "to",
  "Entrega_orderlist__tBPj": "Courier Name",
  "sailing.c-api-intl.交易失败，请核对信息后重试，或更换其他支付方式": "Please contact your bank and try again. Or change another card to pay.",
  "Entrega_order__xKro": "Enter special instructions for the courier here",
  "FoodC_Website_The_WEB_pBbW": "The web version does not support payment with {{pay_name}}. To pay with {{pay_name}}, please download our app",
  "FoodC_cancel_Courier_has_LQtM": "Order accepted by courier",
  "FoodC_recommended_Please_select_dJyk": "Select a Payment Method",
  "Entrega_Website__MiyN": "Please enter a valid email address",
  "Entrega_Website__gWFs": "First name",
  "sailing.launcher-xtx-center.订单已完成": "Support",
  "Entrega_Template__NTCS": "Phone Number",
  "Entrega_batches__xDcS": "1. Download the sample document.",
  "Entrega_order__hETY": "Pricing",
  "Entrega_frontpage__vqPP": "Download the app and start earning money with {{brand_name_food}} or {{brand_name_entrega}}. Best of all, you choose where and when you deliver",
  "Entrega_orderlist__ZBqk": "End Date",
  "FoodC_statement__2_mmNa": "(2) The sender must ensure that the package meets the following packing requirements in order to be suitable for delivery:",
  "FoodC_update_Grand_total_JLev": "Total",
  "Entrega_Website__InoK": "Store Address",
  "Entrega_order__qLWr": "Account",
  "Entrega_Website__gYJh": "Please enter store name",
  "Entrega_order__vrTL": "Last name",
  "soda-b-homepage-i18n---必须为%s字": "Must be %s characters",
  "FoodC_presentation_Network_exception_SELs": "Network error. Please try again later",
  "Entrega_frontpage__vDfn": "Real time tracking with live support",
  "Entrega_order__NODA": "Contact History",
  "FoodC_statement__3_PxyO": "(3) After the courier has picked up the package, if delivery cannot be completed due to a reason involving the recipient (including, but not limited to, the recipient declining to receive the package, the recipient not being able to be contacted, or the recipient’s address being incorrect), the right of disposal of the package shall revert to the sender, and any related service fees arising therefrom shall be borne by the sender.",
  "Entrega_batches__IMNL": "Try Again",
  "FoodC_statement_Animals_people_IccN": "Animals, persons, weapons or explosives;",
  "Entrega_frontpage__SiFn": "Have a bike or motorbike?",
  "Entrega_Website__BHFN": "Name",
  "Entrega_Website__WNeD": "Legal CURP",
  "Entrega_order__twAa": "Are you sure you want to delete this recipient’s information?",
  "Entrega_orderlist__UVEe": "Total",
  "Entrega_Template__LQbu": "Notes",
  "Entrega_order__bVVa": "First name",
  "Entrega_frontpage__xEbj": "Sign In",
  "Entrega_batches__uLkG": "Upload Progress",
  "Entrega_order__sndC": "Outside Regular Service Hours",
  "sailing.c-api-intl.金额无效，请核对交易金额后重试": "Invalid amount. Please choose another card or change the method of payment to pay your ride.",
  "Entrega_order__zXtO": "Quick Request",
  "soda-act---支付超时！": "Paid Timeout",
  "Entrega_orderlist__moOk": "Order Status and Corresponding Quick Actions",
  "FoodC_cancel_When_the_PAQq": "If multiple cancellation attempts are detected involving your account, you won’t be able to cancel the order directly, but you can contact Customer Service for assistance",
  "Entrega_frontpage__DxSF": "Send packages from your PC. It’s practical and convenient!",
  "soda-m-i18n---不能少于%s字": "Not less than %s characters",
  "Entrega_Website__ZqQD": "Business Type",
  "Entrega_batches__EZui": "Please enter the recipient’s mobile number",
  "FoodC_statement__4_Nghy": "(4) If the package cannot be delivered because the courier is unable to contact the sender / recipient, the pickup / dropoff location is incorrect, or other reason, the order fee will not be refunded if you cancel, and you will have to contact the courier to negotiate a time and place for returning or re-delivering the package;",
  "Entrega_orderlist__CZCi": "Pay Now",
  "FoodC_revision_Cancel_Order_qOSA": "Cancel Order",
  "soda-act---复制成功": "Copied",
  "Entrega_order__TLcb": "Package Information",
  "FoodC_statement_Currency_or_drqX": "Currency or negotiable instruments;",
  "Entrega_order__PoSj": "Are you sure you want to exit?",
  "Entrega_order__kMQQ": "Become a Delivery Partner",
  "Entrega_order__RxpK": "All Orders Successfully Paid For",
  "Entrega_orderlist__vvoX": "Search",
  "Entrega_Website__LHDQ": "Last name",
  "FoodC_statement_If_you_Jbkm": "If you discover that a package is incomplete, lost, or damaged, or the wrong package was delivered, please contact Customer Service as soon as possible for assistance.",
  "FoodC_statement_3_Flash_IEYW": "3. Cancellation Policy",
  "Entrega_Website__YUgC": "City",
  "Entrega_orderlist__QABY": "Actual paid",
  "FoodC_2_Payment_failed_cDAD": "Payment Error",
  "FoodC_cancel_Users_initiate_suVB": "Customer can submit a cancellation request, which can’t be withdrawn. The cancellation will be completed once the courier has returned the package, and the cash payment for this order will not be returned",
  "Entrega_batches__HjLu": "Internal Code",
  "Entrega_order__Ufct": "Delete",
  "FoodC_statement_Jewelry_vtUc": "Jewelry;",
  "FoodC_statement_Psychotropic_drugs_XUfp": "Psychoactive drugs or narcotics;",
  "Entrega_Template__DOSv": "External Code",
  "FoodC_statement_pornography_WPQI": "Pornographic material;",
  "Entrega_Website__zsNe": "Store Name",
  "Entrega_batches__kelG": "To import several destinations at once and request simultaneous deliveries, follow the instructions below:",
  "Entrega_frontpage__eutu": "Choose your payment method: Cash or card, it’s your call",
  "FoodC_statement_Value_Items_svYm": "Declared value: The value of the package cannot exceed {{value_limit}}",
  "Entrega_order__ixiy": "Import Request",
  "sailing.c-api-intl.交易失败，请联系发卡行核实后重试": "Please contact your bank and try again. Or change another card to pay.",
  "FoodC_statement_Weight_The_kJIL": "Weight: The maximum permitted weight of a package is {{weight_limit}} kg",
  "DiDi_Food_(C)_confirm_receipt_goods_received_zfyG": "Did you receive your order?",
  "Entrega_Website__tzsO": "Change Password",
  "Entrega_batches__SING": "The file size exceeds the limit",
  "Entrega_order__vDLt": "Please enter a valid mobile number",
  "Entrega_Template__HRnO": "City",
  "Entrega_order__ZUqV": "Recipient’s Information {{Number}}",
  "Entrega_orderlist__LVNZ": "Created at",
  "soda-b-web-i18n---请选择": "Please choose",
  "FoodC_unpaid_Payment_KjvL": "Pay",
  "Entrega_frontpage__aFuj": "Become a Courier",
  "soda-act---卡类型": "Card Type",
  "FoodC_statement__4_bDLh": "(4) The recipient shall open the package immediately upon receipt to verify its quantity and condition.",
  "Entrega_Website__gJjE": "Please enter your first name",
  "Entrega_orderlist__qSHv": "Start Date",
  "Entrega_frontpage__GYhs": "Learn More",
  "Entrega_orderlist__SWIc": "Estimated Pickup Time",
  "Entrega_order__ynve": "Weight",
  "FoodC_statement_4_Rules_XuZc": "4. Guidelines for Package Pickup",
  "Entrega_order_kJLM_VXYM": "Calculate to switch",
  "Entrega_order__WDjM": "You’ll be automatically taken to the Order List page",
  "Entrega_order__sfhO": "Pickup Location",
  "Entrega_orderlist__AUmi": "Recipient’s Phone",
  "FoodC_apply2_Details_Progress_rnCv": "Request Status",
  "Entrega_orderlist__eErl": "Order Placed Time",
  "Entrega_Website__SElE": "Please enter actual address",
  "FoodC_revision_Order_Details_aiDd": "Order Details",
  "sailing.c-api-intl.卡冻结，请更换其他支付方式": "Card blocked. Please contact your bank and try again. Or change another card to pay.",
  "FoodC_cancel_Reason_for_vfFe": "Reason for cancellation",
  "Entrega_batches__FtYJ": "This field cannot be blank",
  "sailing.c-api-intl.交易失败，请稍后重试": "Please contact us to help you solve this issue.",
  "Entrega_order__IffJ": "Please enter all required information for the sender",
  "Entrega_Template__TWzv": "Address Details",
  "Entrega_Template__ePIf": "Pickup Information - Only one pickup entry is allowed",
  "Entrega_Website__JBYs": "Please enter legal CURP",
  "Entrega_frontpage__JyGP": "Simultaneous deliveries with real time tracking",
  "Entrega_Template__Xbtn": "Package Information - Add as many items as you want",
  "Entrega_Website__gIQy": "Submit",
  "Entrega_order__donF": "Up to {{number}} recipients are allowed at a time for online orders",
  "sailing.c-api-intl.[提单页]_[总价]": "Total",
  "Entrega_Website__IqJA": "Edit",
  "Entrega_batches__IzME": "Download Template",
  "sailing.c-api-intl.无法识别卡信息，请核对信息后重试，或更换其他支付方式": "Please contact your bank and try again. Or change another card to pay.",
  "Entrega_batches__YVXX": "2. Fill out the required fields. (Instructions are provided in the document)",
  "FoodC_statement__2_Gymp": "(2) A free cancellation window is provided after the courier accepts your order and before the package is picked up by the courier; once this window has elapsed, a Cancellation Fee will apply if you cancel;",
  "FoodC_part3_Order_List_uPvS": "Orders",
  "Entrega_Website__KeKD": "Mobile Number",
  "Entrega_order__bWrw": "Cancel",
  "FoodC_statement__1_hBNr": "(1) After the courier accepts an order, the sender must be available to answer their phone and be present at the pickup location to meet the courier on time;",
  "FoodC_statement__1_ZXJA": "(1) To send a package, the sender simply enters the pickup and dropoff addresses, contact information of the sender and recipient, and details about the package in the app;",
  "Entrega_batches__thYx": "The existing information will be overwritten. Are you sure you want to try again?",
  "sailing.c-api-intl.卡已失效，请更换其他支付方式": "Card expired. Please contact your bank and try again. Or change another card to pay.",
  "Entrega_frontpage__GYAk": "Recipients will receive a security code to give to the courier to confirm delivery",
  "Entrega_frontpage__txIf": "Send Multiple Packages",
  "FoodC_cancel__free_pPaN": "Customer may cancel for a {{cancellation_fee}} Cancellation Fee more than {{free_time}} min(s) after the courier has accepted the order",
  "FoodC_cancel_Order_accepted_DmOH": "Waiting for courier to accept",
  "FoodC_statement_6_Lost_VmQE": "6. Guidelines for Handling Lost or Damaged Packages",
  "Entrega_frontpage__ISae": "With {{brand_name}}, deliver all that your customers need",
  "FoodC_cancel_Wait_uNLX": "Not Now",
  "Entrega_order__XivI": "Please enter all required information for the recipient",
  "Entrega_batches_Ezlu_yFWe": "Enter order No.",
  "FoodC_statement_5_Rules_eBJs": "5.  Guidelines for Delivery Confirmation",
  "FoodC_statement_Items_prohibited_vdcx": "Any other item prohibited by relevant laws and regulations.",
  "Entrega_Website__VXTL": "Please select pickup location",
  "Entrega_Website__tlRd": "I agree to the {{TC}}",
  "Entrega_order__LAgj": "Please enter apartment number / name",
  "Entrega_order__OFFz": "Sender’s Information",
  "Entrega_order__tUWq": "Address Details",
  "sailing.c-api-intl.发卡行异常，请更换其他支付方式": "Please contact your bank and try again. Or change another card to pay.",
  "Entrega_frontpage__jnfB": "More about {{brand_name}}",
  "Entrega_Template__DzTR": "Street",
  "Entrega_frontpage__rqcd": "Shipping orders are generated automatically based on the package information you enter",
  "FoodC_statement_Volume_The_wFKH": "Dimensions: The length, width and height of a package cannot exceed {{length_limit}} cm x {{width_limit}} cm x {{height_limit}} cm",
  "Entrega_batches__Olse": "4. Confirm all information.",
  "Entrega_order__tugw": "Please select pickup location",
  "Entrega_batches__OGkF": "Import order details",
  "FoodC_statement__6_cuGI": "(6) If the courier discovers upon pickup that the package to be delivered does not comply with the packing requirements or package content policy, the courier may cancel the order, and your package will not be delivered.",
  "Entrega_order__ozpr": "About {{brand}}",
  "FoodC_statement_Currently_DiDi_jUEl": "{{entrega_name}} is a dedicated delivery service that lets you place an order in the app for a courier to pick up and deliver a package to a specified location or recipient nearby. After a courier accepts your order, they will pick up the package at your specified address and deliver it to your chosen destination or recipient.",
  "FoodC_statement_Drugs_controlled_drMh": "Controlled or restricted drugs;",
  "Entrega_orderlist__pKjE": "Download File",
  "FoodC_statement__3_JHtK": "(3) As the requester/sender, you are responsible for bearing the costs associated with the order. For orders paid in the app, payment must be completed at the time the order is placed; for orders paid in cash, payment must be made to the courier at the time of pickup. The recipient is not liable for any charges or fees;",
  "Entrega_Website__PoAN": "Cancel",
  "Entrega_orderlist__rEhM": "Order History",
  "FoodC_statement_1_What_SFNM": "1. What is {{entrega_name}}?",
  "FoodC_cancel_When_an_XxLF": "For in-app payments, a Cancellation Fee will not exceed the actual delivery fee",
  "FoodC_perception_View_Uhmy": "Check Out",
  "Entrega_batches__aqwL": "Unsupported Format",
  "FoodC_statement_Dangerous_materials_tLOa": "Hazardous materials or waste (flammable liquids or solids; compressed gases stored in liquefied, non-liquefied or dissolved form; toxic, infectious, radioactive or corrosive substances);",
  "Entrega_frontpage__lrXS": "Fast and efficient routes",
  "FoodC_statement_Type_You_sJki": "Package content: {{entrega_name}} cannot be used to deliver prohibited items including, but not limited to, any of the following:",
  "Entrega_order__CCFZ": "Please enter the sender’s mobile number",
  "Entrega_frontpage__EBme": "Deliveries start at just {{fee_amount}}",
  "sailing.c-api-intl.内部系统错误": "Payment system is busy; please try again later.",
  "Entrega_orderlist__XPzy": "View Order Details",
  "FoodC_statement__5_ZbOp": "(5) If you discover that the package is lost, damaged, or incomplete, or the wrong package was delivered, please first discuss the issue of compensation with the courier; if a resolution cannot be reached, please contact Customer Service to resolve the issue.",
  "Entrega_order__Jxze": "Partner with us",
  "Entrega_batches__qVQU": "Pickup Location",
  "FoodD_up_Rule_description_dqPm": "Package Guidelines",
  "Entrega_Website__Zcma": "Package Type",
  "Entrega_translate_VqaZ_ibpx": "Order Filter"
}